@if (notifications.length > 0) {
    <div class="absolute bottom-16 right-3 z-notifications m-4 h-auto w-80">
        @for (notification of notifications; track trackNotification(index, notification); let index = $index) {
            <div
                class="relative mb-2 flex justify-between rounded-2xl p-4 text-base text-white shadow-md"
                [class.bg-secondary]="notification.type === 'success'"
                [class.bg-danger]="notification.type === 'error'"
                [class.bg-warning]="notification.type === 'warning'"
            >
                <div class="w-11/12 break-words">
                    <p [innerHTML]="notification.message"></p>
                    @if (notification.linkUrl !== undefined) {
                        <a type="button" class="underline hover:text-white" [href]="notification.linkUrl">{{ notification.linkLabel }}</a>
                    }
                </div>
                <button type="button" class="icon-button flex" (click)="deleteNotification(index)" (keypress)="deleteNotification(index)">
                    <fa-icon class="mr-0 text-white" [icon]="faXmark" />
                </button>
            </div>
        }
        @if (notifications.length >= 2) {
            <div>
                <button
                    type="button"
                    class="button-primary mb-2 w-full rounded-2xl text-white shadow-md"
                    (click)="clearNotifications()"
                    (keypress)="clearNotifications()"
                    i18n="@@notifications.closeAll"
                    >Sluit alles</button
                >
            </div>
        }
    </div>
}
